import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgbModule, NgbModal} from '@ng-bootstrap/ng-bootstrap';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { Ng2IziToastModule } from 'ng2-izitoast';
import {AutocompleteLibModule} from 'angular-ng-autocomplete';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { EscuelasComponent } from './catalogos/escuelas/escuelas.component';
import { NavbarComponent } from './generales/navbar/navbar.component';
import { ClientesComponent } from './admin/clientes/clientes.component';
import { GruposComponent } from './admin/grupos/grupos.component';
import { GruposV2Component } from './admin/grupos-v2/grupos-v2.component';
import { MoldurasComponent } from './catalogos/molduras/molduras.component';
import { PlantillasComponent } from './catalogos/plantillas/plantillas.component';
import { PlacasComponent } from './catalogos/placas/placas.component';
import { AnillosComponent } from './catalogos/anillos/anillos.component';
import { CarrerasComponent } from './catalogos/carreras/carreras.component';
import { RegistroComponent } from './cliente/registro/registro.component';
import { FondosComponent } from './catalogos/fondos/fondos.component';
import { SesionTematicaComponent } from './catalogos/sesion-tematica/sesion-tematica.component';
import { EstolasComponent } from './catalogos/estolas/estolas.component';
import { PaquetesComponent } from './catalogos/paquetes/paquetes.component';
import { ProductsComponent } from './catalogos/products/products.component';
import { InicioComponent } from './admin/inicio/inicio.component';
import { ColoresComponent } from './catalogos/colores/colores.component';
import { UsuariosComponent } from './admin/usuarios/usuarios.component';
import { PerfilComponent } from './cliente/perfil/perfil.component';
import { MunicipiosComponent } from './catalogos/municipios/municipios.component';
import { MiPaqueteComponent } from './cliente/mi-paquete/mi-paquete.component';
import { DatosComponent } from './cliente/datos/datos.component';
import { NavClienteComponent } from './cliente/nav-cliente/nav-cliente.component';
import { MisPagosComponent } from './cliente/mis-pagos/mis-pagos.component';
import { MiGrupoComponent } from './cliente/mi-grupo/mi-grupo.component';
import { ViajesComponent } from './catalogos/viajes/viajes.component';
import { FiestasComponent } from './catalogos/fiestas/fiestas.component';
import { PrecioAnillosComponent } from './catalogos/precio-anillos/precio-anillos.component';
import { CodigosDescuentoComponent } from './catalogos/codigos-descuento/codigos-descuento.component';
import { DetallePaqueteClienteComponent } from './detalle-paquete-cliente/detalle-paquete-cliente.component';
import { DetallePaqueteComponent } from './admin/detalle-paquete/detalle-paquete.component';
import { DedicatoriasComponent } from './admin/dedicatorias/dedicatorias.component';
import { IniciarSesionComponent } from './cliente/iniciar-sesion/iniciar-sesion.component';
import { ObtenerContrasenaComponent } from './cliente/obtener-contrasena/obtener-contrasena.component';
import { FondosMoldurasComponent } from './catalogos/fondos-molduras/fondos-molduras.component';
import { DetalleGrupoComponent } from './admin/detalle-grupo/detalle-grupo.component';
import { ReporteProduccionComponent } from './admin/reporte-produccion/reporte-produccion.component';
import { ReporteVentasComponent } from './admin/reporte-ventas/reporte-ventas.component';
import { ReporteRegistroComponent } from './admin/reporte-registro/reporte-registro.component';
import { ReporteGruposComponent } from './admin/reporte-grupos/reporte-grupos.component';
import { RegistrarmeComponent } from './cliente/registrarme/registrarme.component';
import { ElegirPaqueteComponent } from './cliente/elegir-paquete/elegir-paquete.component';
import { IniciarNuevoComponent } from './cliente/iniciar-nuevo/iniciar-nuevo.component';
import { GastosComponent } from './admin/gastos/gastos.component';
import { DashboardComponent } from './admin/dashboard/dashboard.component';
import { ComprasAdicionalesComponent } from './admin/compras-adicionales/compras-adicionales.component';
import { MisFotosComponent } from './cliente/mis-fotos/mis-fotos.component';
import { FotosGruposComponent } from './admin/fotos-grupos/fotos-grupos.component';
import { StripePayComponent } from './cliente/stripe-pay/stripe-pay.component';
import { InsumosComponent } from './admin/insumos/insumos.component';
import { ProveedoresComponent } from './admin/proveedores/proveedores.component';
import { FlujoEfectivoComponent } from './admin/flujo-efectivo/flujo-efectivo.component';
import { AlertasComponent } from './admin/alertas/alertas.component';
import { HojaEntregaComponent } from './admin/hoja-entrega/hoja-entrega.component';
import { ReporteInsumosComponent } from './admin/reporte-insumos/reporte-insumos.component';
import { ContenidoComponent } from './admin/contenido/contenido.component';
import { RegistroInternoComponent } from './admin/registro-interno/registro-interno.component';
import { CategoriasComponent } from './catalogos/categorias/categorias.component';
import { DiplomasComponent } from './catalogos/diplomas/diplomas.component';
import { AgradecimientosComponent } from './catalogos/agradecimientos/agradecimientos.component';
import { SeleccionarPaqueteComponent } from './cliente/seleccionar-paquete/seleccionar-paquete.component';
import { SeleccionarDetallesComponent } from './cliente/seleccionar-detalles/seleccionar-detalles.component';
import { SeleccionarMarcoComponent } from './cliente/seleccionar-marco/seleccionar-marco.component';
import { V2FamiliasComponent } from './admin/v2-familias/v2-familias.component';
import { V2PaquetesComponent } from './admin/v2-paquetes/v2-paquetes.component';
import { V2ProductosComponent } from './admin/v2-productos/v2-productos.component';
import { V2VariacionesComponent } from './admin/v2-variaciones/v2-variaciones.component';
import { V2inicioComponent } from './clientev2/v2inicio/v2inicio.component';
import { V2paquetesComponent } from './clientev2/v2paquetes/v2paquetes.component';
import { CommonModule } from '@angular/common';
import { V2seguimientoComponent } from './clientev2/v2seguimiento/v2seguimiento.component';
import { V2procesoDemoComponent } from './clientev2/v2proceso-demo/v2proceso-demo.component';
import { RealizarPagoComponent } from './cliente/realizar-pago/realizar-pago.component';
import { PagoConfirmadoComponent } from './cliente/pago-confirmado/pago-confirmado.component';
import { FichaPagoOxxoComponent } from './cliente/ficha-pago-oxxo/ficha-pago-oxxo.component';
import { ContratoAuriComponent } from './cliente/contrato-auri/contrato-auri.component';
import { AvisoPrivacidadComponent } from './cliente/aviso-privacidad/aviso-privacidad.component';

@NgModule({
  declarations: [
    AppComponent,
    EscuelasComponent,
    NavbarComponent,
    ClientesComponent,
    GruposComponent,
    GruposV2Component,
    MoldurasComponent,
    PlantillasComponent,
    PlacasComponent,
    AnillosComponent,
    CarrerasComponent,
    RegistroComponent,
    FondosComponent,
    SesionTematicaComponent,
    EstolasComponent,
    PaquetesComponent,
    ProductsComponent,
    InicioComponent,
    ColoresComponent,
    UsuariosComponent,
    PerfilComponent,
    MunicipiosComponent,
    MiPaqueteComponent,
    DatosComponent,
    NavClienteComponent,
    MisPagosComponent,
    MiGrupoComponent,
    ViajesComponent,
    FiestasComponent,
    PrecioAnillosComponent,
    CodigosDescuentoComponent,
    DetallePaqueteClienteComponent,
    DetallePaqueteComponent,
    DedicatoriasComponent,
    IniciarSesionComponent,
    ObtenerContrasenaComponent,
    FondosMoldurasComponent,
    DetalleGrupoComponent,
    ReporteProduccionComponent,
    ReporteVentasComponent,
    ReporteRegistroComponent,
    ReporteGruposComponent,
    RegistrarmeComponent,
    ElegirPaqueteComponent,
    IniciarNuevoComponent,
    GastosComponent,
    DashboardComponent,
    ComprasAdicionalesComponent,
    MisFotosComponent,
    FotosGruposComponent,
    StripePayComponent,
    RealizarPagoComponent,
    PagoConfirmadoComponent,
    FichaPagoOxxoComponent,
    ContratoAuriComponent,
    AvisoPrivacidadComponent,
    InsumosComponent,
    ProveedoresComponent,
    FlujoEfectivoComponent,
    AlertasComponent,
    HojaEntregaComponent,
    ReporteInsumosComponent,
    ContenidoComponent,
    RegistroInternoComponent,
    CategoriasComponent,
    DiplomasComponent,
    AgradecimientosComponent,
    SeleccionarPaqueteComponent,
    SeleccionarDetallesComponent,
    SeleccionarMarcoComponent,
    V2FamiliasComponent,
    V2PaquetesComponent,
    V2ProductosComponent,
    V2VariacionesComponent,

    // cliente v2

    V2inicioComponent,
    V2paquetesComponent,
    V2seguimientoComponent,
    V2procesoDemoComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    NgbModule,
    FormsModule,
    NgxPaginationModule,
    AppRoutingModule,
    HttpClientModule,
    DataTablesModule,
    Ng2IziToastModule,
    AutocompleteLibModule,
    ReactiveFormsModule,    
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
